module.exports = __webpack_public_path__ + "static/media/Flag_of_Sweden.8bfeb3c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/Flag_of_Sweden.png
// module id = 453
// module chunks = 0